import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { AuthUser } from '../../core/auth/auth.service';
import { IconComponent } from '../../shared/components/icon/icon.component';

/** User-chip della topbar (STILE-VISUALE.md §4.1): avatar oro con iniziali + nome + ruolo, menu a tendina. */
@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [RouterLink, NzDropdownModule, NzMenuModule, IconComponent],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent {
  readonly user = input<AuthUser | null>(null);
  readonly roleName = input<string | null>(null);
  readonly darkTheme = input(false);
  readonly toggleTheme = output<void>();

  // "anna.fabbri" → "AF"; "operatore" → "OP"
  readonly initials = computed(() => {
    const parts = (this.user()?.username ?? '').split(/[.\s_-]+/).filter(Boolean);
    const letters = parts.length > 1 ? parts[0][0] + parts[1][0] : (parts[0] ?? '').slice(0, 2);
    return letters.toUpperCase();
  });
}
